module.exports = __webpack_public_path__ + "static/img/icon2.087a2b68.png";